(ns hai.library.sources.routes
  (:require
   [hai.library.sources.create :as create]
   [hai.library.sources.show :as show]
   [hai.library.sources.table :as table]
   [hai.ui.icons :as icons]
   [hai.ui.rf-sugar :refer [>e]]
   [hai.web-app.routing :as routing]))

(defn routes []
  [["/sources"
    {::routing/window-title "Sources"
     :icon icons/outlined-storage}
    [""
     {:name        :sources/table
      :label       "Knowledge"
      :breadcrumbs ["Knowledge"]
      :view        table/page}]
    [""
     {:breadcrumbs [:sources/table]
      :label "Add Source"}
     ["/new"
      {:name :sources/new
       ::routing/window-title "New Source"
       :view create/page}]
     ["/create/{source/type}"
      {:name :sources/create
       :view create/page}]]
    ["/show/{ai-source/uuid}"
     {:name :ai-sources/show
      :view show/page
      :controllers [{:parameters {:path [:ai-source/uuid]
                                  :query [:ai-model-config/uuid]}
                     :start (fn [{source :path
                                  assistant :query}]
                              (>e [:entity/resolve source {:request-id [:ai-sources/show (:ai-source/uuid source)]}])
                              (when (:ai-model-config/uuid assistant)
                                (>e [:entity/resolve assistant {:request-id [:ai-sources/show-assistant (:ai-model-config/uuid assistant)]}])))}]}]]])
